import classNames from "classnames";

interface IConfidenceBadgeProps {
    confidenceRating?: number;
    confidenceLevel?: number;
}

export function ConfidenceBadge(props: IConfidenceBadgeProps) {
    const getConfidenceClassName = (confidenceLevel: number | undefined) => {
        if (confidenceLevel) {
            if (confidenceLevel == 1) {
                return 'color-orange';
            } else if (confidenceLevel == 2) {
                return 'color-yellow';
            } else if (confidenceLevel == 3) {
                return 'color-green';
            }
        }
        return '';
    };

    const confidenceClassName = getConfidenceClassName(props.confidenceLevel);

    return (
        <div className={confidenceClassName}>
            <span className={classNames(confidenceClassName, 'bold')}>
                {props.confidenceRating}
            </span>
        </div>
    );
}
